import { Avatar, Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Table from "../../../core-components/theme/components/Table/Table";
import useFMListingView from "../hooks/useFMListingView";
import SpriteIcon from "../../../core-components/assets/Icon";
import React from "react";
import { Primary } from "../../../core-components/theme/color-palette/colors";
import FMListingActionDropdown from "./FMListingActionDropdown";
import FMFileViewer from "../Dialogs/FMFileViwer";
import useIsDesktop from "../../../utilities/customHooks/useIsDesktop";
import { getFileTypeFromMime, getIconTypeFromMime } from "../../../utilities/helpers";
import NoDataView from "../../../globalComponents/NoDataView/NoDataView";

const FMListTable = ({queryKeyData}: any) => {
    const { t } = useTranslation();
    const {tableContainerRef, lastElementRef, listData, uploaderChipStyles, selectedFile, getRelativeTime, handleView, handleDelete, handleCloseFileViewer} = useFMListingView(queryKeyData);
    const isTableAndAbove = useIsDesktop(767);

    const renderFileType = (value: string) => {
      if (!value) return null;
      const iconType = getIconTypeFromMime(value);
      const fileType = getFileTypeFromMime(value);
      return (
      <Tooltip title={fileType || ''}>
        <span>
          <SpriteIcon id={iconType} width="30" height="42"/>
        </span>
       </Tooltip>
      )
    }

    const renderUploadedBy = (value: any) => {
        if (!value) return null;
        let {name} = value;
        return (
          <Chip
            label={name}
            color="primary"
            size="medium"
            sx={uploaderChipStyles}
            icon={<Avatar sx={{ bgcolor: Primary[900], color: '#fff !important', width: 16, height: 16, fontSize: '8px !important' }} sizes="small">{name.substr(0, 2).toUpperCase()}</Avatar>}
          />
        )
    }

  const sensorColumns: any = [
    {
      field: 'fileName',
      headerName: t('fileManager.columns.documentName', 'Document Name'),
      width: 250,
      minWidth: 250,
      maxWidth: 250,
      renderCell: (value: string, row: { updatedAt: string}) => {
        return (
          <Stack sx={{ display: 'flex', overflow: 'hidden' }}>
            <Tooltip title={value || ''}>
              <Typography noWrap variant="h4">
                {value || ''}
              </Typography>
            </Tooltip>
            <Typography noWrap variant="caption" color="#999" sx={{ marginLeft: 1 }}>
              {getRelativeTime(row?.updatedAt)}
            </Typography>
          </Stack>
        );
      },
    },

    {
      field: 'fileType',
      headerName: t('fileManager.columns.fileType', 'File Type'),
      align: 'center',
      renderCell: (value: any) => {
        return (
          <React.Fragment>
            {renderFileType(value)}
          </React.Fragment>
        );
      },
    },
    {
      field: 'category',
      headerName: t('fileManager.category', 'Category'),
      renderCell: (value: string) => {
        return (
          <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            <Typography variant="h4" noWrap>
              {value}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: 'subCategory',
      headerName: t('fileManager.subCategory', 'Sub Category'),
      renderCell: (value: string) => {
        return (
          <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            <Typography variant="h4" noWrap>
              {value}
            </Typography>
          </Stack>
        );
      },
    },
    {
      field: 'uploaderId',
      headerName: t('fileManager.columns.uploadedBy', 'Uploaded By'),
      renderCell: (value: string) => {
        return (
          <Stack direction="row" sx={{ display: 'flex', alignItems: 'center', overflow: 'hidden' }}>
            {renderUploadedBy(value)}
          </Stack>
        );
      },
    },
  ];


  if (listData.length === 0) {
    return (
      <Box sx={{ height: isTableAndAbove ? '68vh' : '77vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <NoDataView message={t('common.noDataAvailable', 'No data available')} />
        {
          selectedFile &&
          <FMFileViewer
            fileUrl={`https://d2hff4tqy2wftm.cloudfront.net/${selectedFile?.s3Key}`}
            mimeType={selectedFile?.fileType}
            fileName={selectedFile?.fileName}
            handleClose={handleCloseFileViewer}
           />
        }
      </Box>
    );
  }

  return (
    <Box ref={tableContainerRef}>
      <Box sx={{ height: (isTableAndAbove ? '68vh' : '77vh') }}>
        <Table
          stickyHeader
          rows={listData}
          columns={sensorColumns}
          lastRowRef={lastElementRef}
          tableContainerSx={{ height: '100%' }}
          renderOptionsCell={(row) => (
            <FMListingActionDropdown
              row={row}
              handleView={handleView}
              handleDelete={handleDelete}

            />
          )}
        />
      </Box>
      {
        selectedFile &&
        <FMFileViewer
          fileUrl={`https://d2hff4tqy2wftm.cloudfront.net/${selectedFile?.s3Key}`}
          mimeType={selectedFile?.fileType}
          fileName={selectedFile?.fileName}
          handleClose={handleCloseFileViewer}
         />
      }
    </Box>
  );
}

export default FMListTable;